import { Divider, Drawer, Space, Select, Tooltip, Checkbox, Slider, InputNumber } from "antd";
import React, { useState, useEffect } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import PositionAlign from "../../UI/PositionAlign";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import MobileSelector from "../../UI/MobileSelector";
import { useTemplate } from "../../../utils/Template";
import SliderInput from "../../UI/SiderInput";
import { apiCall, fetchImage } from "../../../utils/Api";
import { PaddingHorizontalIcon, PaddingVerticalIcon, AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from "../../Icons";
import { tt_ig_display, tt_ig_gap_x, tt_ig_gap_y, tt_ig_padding_x, tt_ig_padding_y, tt_name_block_warning } from "../../../utils/Utils";

import PresetPicker from "../../../globals/styles/PresetPicker";
import moment from "moment";
import LinkPicker from "../../../globals/styles/LinkPicker";
import CategorySelector from "../../UI/CategorySelector";

export default function EventsGrid(props) {
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, view = "desktop", setView = () => { }, id = 0 } = props;
    const [template,] = useTemplate();
    const [content, setContent] = useState(props.content);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mobile, setMobile] = useState(false);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        width = 300,
        height = 300,
        padding_y = 0,
        padding_x = 0,
        horizontal_align = "center",
        vertical_align = "center",
        size = "cover",
        gap_y = 10,
        gap_x = 10,
        justify = "center",
        background_colour = 0,
        image_radius = 0,
        spacing = 10,
        categories = [],
        limit = 8,
        title_preset = 0,
        date_preset = 0,
        link_style = 0,
        text_align = "center",

        allow_mobile_overrides = false,
        mobile_height = 300,
        mobile_padding_y = 0,
        mobile_padding_x = 0
    } = data;


    const fetchEvents = () => {
        setLoading(true);

        if (window.sitesettings.using_events_v2) {

            let obj = {
                limit: 24,
                start_date: moment().tz('America/Los_Angeles').format("YYYYMMDD")
            }

            if (categories.length > 0) {
                obj.categories = JSON.stringify([...categories].map(item => item.id));
            }

            apiCall("event/v2/list", obj, (_status, _result) => {
                if (_status) {
                    if (edit) {
                        setEvents(_result.rows);
                    } else {
                        setEvents((prevRows) => [...prevRows, ..._result.rows]);
                    }

                }
                setLoading(false)
            }, "customer")
        } else {

            apiCall("event/getList", { from: moment().tz('America/Los_Angeles').format("YYYYMMDD") }, (_status, _result) => {
                if (_status) {
                    setEvents(_result.rows);
                }
                setLoading(false);
            }, "customer")
        }
    }
    useEffect(fetchEvents, [categories]);


    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const formatDate = (_event) => {
        let { date = "", from = "", to = "", end_date = "", recurring_as_single_row = false  } = _event;
        if (window.sitesettings.using_events_v2) {

            if(recurring_as_single_row && end_date){
                return moment(date, "YYYYMMDD").tz('America/Los_Angeles').format("ddd MMM Do, YYYY") + " to " + moment(end_date, "YYYYMMDD").tz('America/Los_Angeles').format("ddd MMM Do, YYYY");
            }
            return moment(date, "YYYYMMDD").format("MMM Do");
        } else {
            let _to = moment(to * 1000).tz('America/Los_Angeles').format("MMM Do");
            let _from = moment(to * 1000).tz('America/Los_Angeles').format("MMM Do");
            if (_to === _from) {
                return _from;
            } else {
                return _from + "-" + _to;
            }
        }
    }

    const drawEvent = (_event, _index) => {

        let _img = (window.sitesettings.using_events_v2) ? `url('${fetchImage(_event.image_url)}')` : `url('${fetchImage(_event.info.img_path)}')`;
        let _title = (window.sitesettings.using_events_v2) ? _event.title : _event.info.name;
        let _coverStyle = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            objectFit: "cover",
            height: (allow_mobile_overrides && view !== "desktop") ? mobile_height + "px" : height + "px",
            width: (allow_mobile_overrides && view !== "desktop") ? "100%" : width + "px",
            backgroundRepeat: "no-repeat",
            backgroundImage: _img,
            backgroundSize: size,
            backgroundPosition: vertical_align + " " + horizontal_align,
            borderRadius: image_radius + "px"
        }


        return (
            <div style={{ "maxWidth": width + "px", width: (allow_mobile_overrides && view !== "desktop") ? "100%" : "auto"}}>
                <Space size={spacing} direction="vertical" style={{width: "100%"}}>
                    <div className="bm-img-link" title={_title} style={_coverStyle} key={_index}></div>
                    <div className={"bm-txt-" + date_preset} style={{ "textAlign": text_align }}>{formatDate(_event)}</div>
                    <div className={"bm-txt-" + title_preset} style={{ "textAlign": text_align }}><a className={"bm-lnk-" + link_style}>{_title}</a></div>
                </Space>
            </div>
        )
    }

    const drawRender = () => {
        const gridStyle = {
            background: getColor(background_colour, template),
            display: 'flex',
            flexWrap: "wrap",
            justifyContent: justify,
            gap: `${gap_y}px ${gap_x}px`,
            padding:  (allow_mobile_overrides && view !== "desktop") ? `${mobile_padding_y}px ${mobile_padding_x}px` : `${padding_y}px ${padding_x}px`,
        };
        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={gridStyle}>
                    {events.slice(0, limit).map((item, index) => {
                        return drawEvent(item, index);
                    })}
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    const drawMobile = () => {
        return (
            <>
                <div>
                    <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                    <div className="shim" /><div className="shim" />
                    {/* HEIGHT */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">POSTER HEIGHT</Divider>
                    <SliderInput
                        width={150}
                        min={0}
                        max={600}
                        onChange={(_v) => setData({ ...data, "mobile_height": _v })}
                        disabled={!allow_mobile_overrides}
                        value={mobile_height}
                    />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                    <div className="float-flex">
                        <Space>
                            <BMInput width={46} value={mobile_padding_x} onChange={(_v) => setData({ ...data, "mobile_padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput width={46} value={mobile_padding_y} onChange={(_v) => setData({ ...data, "mobile_padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        </Space>
                    </div>
                    <div className="shim" /> <div className="shim" />
                </div>
            </>
        )
    }

    const drawDesktop = () => {
        return (
            <>
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAP</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput width={46} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput width={46} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                    <Space>
                        <BMInput width={46} value={gap_x} onChange={(_v) => setData({ ...data, "gap_x": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_ig_gap_x} >X</Tooltip>} />
                        <BMInput width={46} value={gap_y} onChange={(_v) => setData({ ...data, "gap_y": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_ig_gap_y}>Y</Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* GUTTER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GRID ALIGN</Divider>
                <Select value={justify} onChange={(e) => setData({ ...data, "justify": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"center"} value={"center"}><small>Centre</small></Select.Option>
                    <Select.Option key={"start"} value={"start"}><small>Left</small></Select.Option>
                    <Select.Option key={"end"} value={"end"}><small>Right</small></Select.Option>
                    <Select.Option key={"space-between"} value={"space-between"}><small>Space Between</small></Select.Option>
                    <Select.Option key={"space-evenly"} value={"space-evenly"}><small>Space Evenly</small></Select.Option>
                    <Select.Option key={"space-around"} value={"space-around"}><small>Space Around</small></Select.Option>
                </Select>

                <div className="shim" /> <div className="shim" />

                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>

                {/* CATEGORIES */}
                {(window.sitesettings.using_events_v2 && <>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT CATEGORIES</Divider>
                    <CategorySelector value={categories} onChange={(e) => setData({ ...data, "categories": e })} />
                    <div className="shim" /> <div className="shim" />
                </>)}


                {/* TITLE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT TITLE PRESET</Divider>
                <PresetPicker value={title_preset} onChange={(e) => setData({ ...data, "title_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT LINK STYLE</Divider>
                <LinkPicker value={link_style} onChange={(e) => setData({ ...data, "link_style": e })} />
                <div className="shim" /> <div className="shim" />

                {/* DATE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DATE/TIME PRESET</Divider>
                <PresetPicker value={date_preset} onChange={(e) => setData({ ...data, "date_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* TEXT ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN / SPACING</Divider>

                <div className="float-flex">
                    <Space>
                        <div><AlignLeftIcon onClick={() => setData({ ...data, "text_align": "left" })} style={{ "color": (text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignCenterIcon onClick={() => setData({ ...data, "text_align": "center" })} style={{ "color": (text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignRightIcon onClick={() => setData({ ...data, "text_align": "right" })} style={{ "color": (text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <Space>
                        <BMInput value={spacing} onChange={(_v) => setData({ ...data, "spacing": _v })} number min={4} max={24} prefix="SPACING" />
                    </Space>
                </div>


                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LIMIT</Divider>
                <BMInput value={limit} onChange={(_v) => setData({ ...data, "limit": _v })} number min={4} max={24} prefix="MAX" />
                {/* MAX EVENTS */}
                <div className="shim" /> <div className="shim" />
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>

                {/* IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">POSTER ALIGN & DISPLAY</Divider>
                <div className="float-flex">
                    <Space>
                        <PositionAlign value={horizontal_align} onChange={(e) => setData({ ...data, "horizontal_align": e })} />
                        <PositionAlign type="vertical" value={vertical_align} onChange={(e) => setData({ ...data, "vertical_align": e })} />
                    </Space>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <Select value={size} onChange={(e) => setData({ ...data, "size": e })} size="small" style={{ "width": "100%" }} >
                        <Select.Option key="cover" value="cover"><small>Cover</small></Select.Option>
                        <Select.Option key="contain" value="contain"><small>Contain</small></Select.Option>
                        <Select.Option key="initial" value="initial"><small>Initial</small></Select.Option>
                    </Select>
                </div>
                <div className="shim" /> <div className="shim" /><div className="shim" />

                {/* WIDTH / HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">POSTER WIDTH & HEIGHT / RADIUS</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput width={46} value={width} onChange={(_v) => setData({ ...data, "width": _v })} number min={50} max={1248} prefix="WIDTH" />
                        <BMInput width={46} value={height} onChange={(_v) => setData({ ...data, "height": _v })} number min={50} max={1248} prefix="HEIGHT" />
                        <BMInput width={"40px"} value={image_radius} onChange={(e) => setData({ ...data, "image_radius": e })} number min={0} max={1000} prefix="RADIUS" />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />


            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}